import React from 'react';
import styled from 'styled-components';
import SingleTagItem from './SingleTagItem';
import { EATING_TAGS } from '../../constants/appConstants';

const CategoryTagsGroup = ({ categoryId, title, tags, confirmDeletingTag, editingTag }) => {
  return (
    <React.Fragment>
      <TagsCategoryTitle>{title}</TagsCategoryTitle>
      <TagsGrid>
        {tags.map((tag) => {
          return (
            <SingleTagItem
              key={tag.tag_id}
              name={tag.name}
              can_delete={categoryId !== EATING_TAGS && tag.can_delete}
              isCanEdit={categoryId !== EATING_TAGS}
              tagId={tag.tag_id}
              onDeleteTag={confirmDeletingTag}
              onEditTag={() => editingTag(tag)}
            />
          );
        })}
        <EmptyTagBlock />
        <EmptyTagBlock />
        <EmptyTagBlock />
      </TagsGrid>
    </React.Fragment>
  );
};

export default CategoryTagsGroup;

const TagsCategoryTitle = styled.h3`
  font-size: 25px;
  margin: 10px 20px;
  text-align: left;
`;

const TagsGrid = styled.div`
  width: 100%;
  padding: 0 20px;
  box-sizing: border-box;
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
  align-items: center;
`;

const EmptyTagBlock = styled.div`
  width: 30%;
  position: relative;
  padding: 0px 90px 0px 10px;
  box-sizing: border-box;
`;



// WEBPACK FOOTER //
// ./src/Components/Tags/CategoryTagsGroup.jsx